import { IAcquisitionRepository } from '../../application/ports/repositories/IAcquisitionRepository';
import axios, { AxiosInstance } from 'axios';
import { API_BASE_URL } from '../../config';

export class AxiosAcquisitionRepository implements IAcquisitionRepository {
  private apiClient: AxiosInstance;
  private paths = {
    Leads: '/api/leads',
    LeadConfirmation: '/confirm/purchase',
    EMailConfirmation: '/confirm/email',
    Order: '/api/orders',
    Recall: '/api/recalls',
    Pricing: '/api/prices'
  };

  constructor() {
    this.apiClient = axios.create({
      baseURL: API_BASE_URL,
      timeout: 30000,
      headers: {
        post: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  async createOrder(payload: any): Promise<any> {
    return this.apiClient.post(this.paths.Order, payload);
  }

  async createLead(payload: any): Promise<any> {
    return this.apiClient.post(this.paths.Leads, payload);
  }

  async getLeadById(leadId: string, key: string): Promise<any> {
    return this.apiClient.get(`${this.paths.Leads}/${leadId}`, {
      params: { key }
    });
  }

  async convertLeadToOrder(
    leadId: string,
    orderConfirmationKey: string,
    dataProcessingAgreementVersion: string
  ): Promise<any> {
    return this.apiClient.get(`${this.paths.Leads}/${leadId}${this.paths.LeadConfirmation}`, {
      params: {
        key: orderConfirmationKey,
        data_processing_agreement_version: dataProcessingAgreementVersion
      }
    });
  }
}
